import React, { Component, cloneElement } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import LabelDecorator from '..';

import './index.css';

class FloatingLabel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false,
    };

    this.getClassNames = this.getClassNames.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  getClassNames() {
    const { className } = this.props;
    const { focused } = this.state;
    return classnames({
      LookalikeLabel: true,
      [className]: true,
      focus: focused,
    });
  }

  handleBlur() {
    const { children, onBlur } = this.props;
    const { onBlur: inputBlur } = children.props;
    this.setState(
      {
        focused: false,
      },
      () => {
        onBlur();
        if (inputBlur) inputBlur();
      },
    );
  }

  handleFocus() {
    const { children, onFocus } = this.props;
    const { onFocus: inputFocus } = children.props;
    this.setState(
      {
        focused: true,
      },
      () => {
        onFocus();
        if (inputFocus) inputFocus();
      },
    );
  }

  render() {
    const { handleBlur, handleFocus } = this;
    const { children, label } = this.props;
    const classNames = this.getClassNames();
    return (
      <LabelDecorator label={label} className={classNames} showLabel={false}>
        {cloneElement(children, {
          onBlur: handleBlur,
          onFocus: handleFocus,
        })}
      </LabelDecorator>
    );
  }
}

FloatingLabel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

FloatingLabel.defaultProps = {
  className: '',
  label: '',
  onBlur: noop,
  onFocus: noop,
};

export default FloatingLabel;
